import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.is-frozen.js";
import { useCallback } from 'react';
/**
 * Merges the passed-in react refs.
 */

function useMergedRefs(refs) {
  return useCallback(function (current) {
    refs.forEach(function (ref) {
      if (typeof ref === 'function') {
        ref(current);
      } else if (ref && !Object.isFrozen(ref)) {
        ref.current = current;
      }
    });
    /* The refs must be passed as an array, so it's
     * safe to directly use them as callback dependencies,
     * even though eslint can't statically verify it. */
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, refs);
}
export default useMergedRefs;